import { render } from "./BotOnielVid.vue?vue&type=template&id=98c285bc"
import script from "./BotOnielVid.vue?vue&type=script&lang=js"
export * from "./BotOnielVid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__